'use client';

import {type FC, useCallback, useState} from 'react';
import clsx from 'clsx';

import {Button} from '@/components/button';
import {GridList} from '@/components/grid-list';
import {LinkCard} from '@/components/link-card';
import {formatDate} from '@/utils/format';
import type {KeyedArray} from '@/utils/types';

import type {Article} from '../../../../article/shared/types';

interface Props {
	articles: KeyedArray<Article>;
}

const VISIBLE_ARTICLES_LIMIT = 6;

export const ArticleListSimple: FC<Props> = ({articles}) => {
	const [visibleArticles, setVisibleArticles] = useState<KeyedArray<Article>>(
		articles.slice(0, VISIBLE_ARTICLES_LIMIT),
	);

	const loadMore = useCallback(() => {
		const nextVisibleArticles = articles.slice(
			0,
			visibleArticles?.length + VISIBLE_ARTICLES_LIMIT,
		);
		setVisibleArticles(nextVisibleArticles);
	}, [articles, visibleArticles]);

	if (!visibleArticles) {
		return null;
	}

	const totalArticles = articles?.length;

	const hasMore = visibleArticles.length < totalArticles;

	return (
		<>
			<GridList>
				{visibleArticles && visibleArticles.length && (
					<>
						{visibleArticles.map((article) => {
							if (!article) {
								return null;
							}

							return (
								<li key={article._key}>
									<LinkCard
										href={article.href}
										title={article.title}
										image={article.imageWeb ?? undefined}
										description={article.lead}
										date={formatDate(article.createdAt)}
										tags={article.categories?.map(
											(category) => category.title,
										)}
									/>
								</li>
							);
						})}
					</>
				)}
			</GridList>
			{hasMore && (
				<Button
					onClick={loadMore}
					className={clsx('justify-self-center', 'mt-4')}
				>
					Vis flere artikler
				</Button>
			)}
		</>
	);
};
